import { faComment, faShapes, faStar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const { pathname } = useLocation();

  const elements = [
    {
      label: 'Vorlagen',
      icon: faShapes,
      link: '/modules',
      prefixes: ['/module/', '/modules'],
    },
    {
      label: 'Meine Aktivitäten',
      icon: faComment,
      link: '/tasks',
      prefixes: ['/tasks/', '/task/'],
    },
    {
      label: 'Favoriten',
      icon: faStar,
      link: '/favorites',
    },
  ];

  return (
    <div className="flex space-x-2 h-full">
      {elements.map(({ link, label, icon, prefixes }) => {
        const active = prefixes
          ? pathname === link || prefixes.find((p) => pathname.startsWith(p))
          : pathname.startsWith(link);
        return (
          <div
            key={link}
            className="h-full relative flex justify-center items-center"
          >
            <Link
              to={link}
              className={`hover:text-[var(--theme-primary)] cursor-pointer text-[#222] p-1 px-2 space-x-2 rounded-lg ${active ? 'font-semibold text-[var(--theme-primary)]' : ''}`}
            >
              <FontAwesomeIcon icon={icon} />
              <span className="text-sm">{label}</span>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default Navigation;
